import { render } from "./DocumentViewComponent.vue?vue&type=template&id=5b6898ec&scoped=true"
import script from "./DocumentViewComponent.vue?vue&type=script&lang=js"
export * from "./DocumentViewComponent.vue?vue&type=script&lang=js"

import "./DocumentViewComponent.vue?vue&type=style&index=0&id=5b6898ec&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6898ec"]])

export default __exports__